module.exports = __webpack_public_path__ + "img/sun-collection.3945abf8.jpg";